module.exports = __webpack_public_path__ + "Employer Notice 06_25_2024.pdf";